import { EventPaymentMethod } from "./event-payment-method";
import {EventPaymentType} from "./event-payment-type";

export class EventPaymentSettings {
    eventId?: number;
    mandatoryPayment?: boolean | null;
    paymentMethod?: EventPaymentMethod | null;
    createBarcode?: boolean | null;
    paymentType?: EventPaymentType[] | null;
    issuingInvoice?: boolean | null;
    validHours?: number | null;
    paymentReminder?: boolean | null;
    days?: number | null;
    hours?: number | null;
    reminderMessage?: number | null;
    reminderMethod?: PaymentReminder[] | null;
    displayPaymentStatusForRegistrants?: boolean | null;

    constructor() {
        this.eventId = undefined;
        this.mandatoryPayment = undefined;
        this.paymentMethod = undefined;
        this.createBarcode = undefined;
        this.paymentType = undefined;
        this.issuingInvoice = undefined;
        this.validHours = undefined;
        this.paymentReminder = undefined;
        this.days = undefined;
        this.hours = undefined;
        this.reminderMessage = undefined;
        this.reminderMethod = undefined;
    }
}

enum PaymentReminder {
  EMAIL=1,
  PROFILE=2,
  PUSH_NOTIFICATION=3
}
